import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import { Icon as IconSvelte } from '@glance-networks/ui-core-components';

export const Icon = (props) => {
  const defineProps = {
    size: props.size,
    name: props.name,
    weight: props.weight,
    title: props.title,
    color: props.color,
  };
  return (
    <Svelte component={IconSvelte} {...defineProps} />
  );
};
